export default __webpack_public_path__ + "static/media/landing-page.bdf48695.png";